export const v3HpAdminPath = '/subscriptions'

export const printerEligibilityUrl = (country: string, language: string) =>
  `https://instantink.hpconnected.com/${country}/${language}/l/faq?flow_name=rebrand_responsive`
